// components
import { NotificationsComponent } from './notifications.component';

export const NOTIFICATIONS_COMPONENTS: any[] = [
  NotificationsComponent,
];

// services



// WEBPACK FOOTER //
// ./src/app/components/dashboard/notifications/index.ts